const Permits = {
  HOME: ['admin', 'operator', 'production', 'production_operator', 'packing_manager', 'reception_dispatch_manager', 'schedule_management', 'schedule_management_edit'],
  PURCHASES: ['admin', 'packing_manager'],
  PROCESSES: ['admin', 'operator', 'production', 'production_operator', 'packing_manager', 'reception_dispatch_manager'],
  RECEIPTS: ['admin', 'operator', 'production', 'production_operator', 'packing_manager', 'reception_dispatch_manager'],
  PROCESS: ['admin', 'operator', 'production', 'production_operator', 'packing_manager', 'reception_dispatch_manager'],
  LOTS: ['admin', 'operator', 'packing_manager', 'reception_dispatch_manager'],
  DISPATCHES: ['admin', 'operator', 'production', 'production_operator', 'packing_manager', 'reception_dispatch_manager'],
  RETURNS: ['admin', 'packing_manager', 'reception_dispatch_manager'],
  // Rerports
  INVENTORY_LINES: ['admin', 'packing_manager', 'reception_dispatch_manager'],
  LOT_RESUME: ['admin', 'packing_manager'],
  LOT_TRACEABILITY: ['admin', 'packing_manager'],
  PRODUCTS_REPORT: ['admin'],
  BALANCE: ['admin', 'operator', 'packing_manager', 'reception_dispatch_manager'],
  VERSION_HISTORY: ['admin'],
  // Mantainers
  PRODUCTS: ['admin'],
  SUPPLIERS: ['admin'],
  CLIENTS: ['admin'],
  WORKSHIFTS: ['admin'],
  PROCESS_CATEGORIES: ['admin'],
  PADDOCKS: ['admin'],
  PROCESS_TYPES: ['admin', 'operator', 'production', 'production_operator'],
  SUPPLY_PRODUCTS: ['admin'],
  EMPLOYEES: ['admin'],
  UNITS: ['admin'],
  VARIETIES: ['admin'],
  WAREHOUSES: ['admin'],
  PACKAGING_TYPES: ['admin'],
  FRUITS: ['admin'],
  EQUIPMENTS: ['admin'],
  USERS: ['admin'],
  MODULES: ['admin'],
  SCHEDULE_MANAGEMENT: ['admin', 'schedule_management', 'schedule_management_edit'],
  FEATURE_FLAGS: ['admin'],
  CARRIERS: ['admin'],
  PROCESSING_PLANTS: ['admin'],
};

export default Permits;
